import { useAbility } from "@casl/react";

import { authzPermissionsContext } from "context/authz/config";
import { useAuthz } from "hooks";

interface IToeLinesPermissions {
  canGetAttackedAt: boolean;
  canGetAttackedBy: boolean;
  canGetAttackedLines: boolean;
  canGetBePresentUntil: boolean;
  canGetComments: boolean;
  canGetFirstAttackAt: boolean;
  canGetNeedsReview: boolean;
  canSeeCoverage: boolean;
  canSeeDaysToAttack: boolean;
  canUpdateAttackedLines: boolean;
  groupName: string;
}

export function useToeLinesPermissions(
  groupName: string,
): IToeLinesPermissions {
  const { canMutate, canResolve } = useAuthz();
  const permissions = useAbility(authzPermissionsContext);

  return {
    canGetAttackedAt: canResolve("toe_lines_attacked_at"),
    canGetAttackedBy: canResolve("toe_lines_attacked_by"),
    canGetAttackedLines: canResolve("toe_lines_attacked_lines"),
    canGetBePresentUntil: canResolve("toe_lines_be_present_until"),
    canGetComments: canResolve("toe_lines_comments"),
    canGetFirstAttackAt: canResolve("toe_lines_first_attack_at"),
    canGetNeedsReview: canResolve("toe_lines_needs_review"),
    canSeeCoverage: permissions.can("see_toe_lines_coverage"),
    canSeeDaysToAttack: permissions.can("see_toe_lines_days_to_attack"),
    canUpdateAttackedLines: canMutate("update_toe_lines_attacked_lines"),
    groupName,
  };
}
